import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react';

export const LiveActionsDisabledContext = createContext({
  arrowKeyIsDisabled: {} as boolean,
  setArrowKeyIsDisabled: {} as Dispatch<SetStateAction<boolean>>,
  showMediaIsDisabled: {} as boolean,
  setShowMediaIsDisabled: {} as Dispatch<SetStateAction<boolean>>,
  openFirstAiResponse: {} as (gameId: string, slideId: string) => void,
  setOpenFirstAiResponseHandler: {} as Dispatch<
    SetStateAction<((gameId: string, slideId: string) => void) | undefined>
  >,
});

const LiveActionsDisabledProvider = ({ children }: { children: React.ReactNode }) => {
  const [arrowKeyIsDisabled, setArrowKeyIsDisabled] = useState(false);
  const [showMediaIsDisabled, setShowMediaIsDisabled] = useState(false);
  const [openFirstAiResponseHandler, setOpenFirstAiResponseHandler] = useState<
    ((gameId: string, slideId: string) => void) | undefined
  >(undefined);

  const openFirstAiResponse = useMemo(
    () => (gameId: string, slideId: string) => {
      if (openFirstAiResponseHandler) {
        openFirstAiResponseHandler(gameId, slideId);
      }
    },
    [openFirstAiResponseHandler],
  );

  const value = useMemo(
    () => ({
      arrowKeyIsDisabled,
      setArrowKeyIsDisabled,
      setShowMediaIsDisabled,
      showMediaIsDisabled,
      openFirstAiResponse,
      setOpenFirstAiResponseHandler,
    }),
    [arrowKeyIsDisabled, showMediaIsDisabled, openFirstAiResponse],
  );
  return (
    <LiveActionsDisabledContext.Provider value={value}>
      {children}
    </LiveActionsDisabledContext.Provider>
  );
};

export default LiveActionsDisabledProvider;
